import React from "react";
import { Content, useTranslator } from "@sia/style-guide";
import Page from "../Page";

const NotLoggedInPage = () => {
  const translate = useTranslator();
  return (
    <Page title={""} className={""}>
      <Content>
        <h1>{translate("routing.private.not-logged-in.title")}</h1>
        <p>{translate("routing.private.not-logged-in.text")}</p>
      </Content>
    </Page>
  );
};
export default NotLoggedInPage;
